// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmAclDept {
constructor({
        id = null,
        code = '',
        name = '',
        parentId = '',
        seq = '',
        externalId = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.parentId = parentId;
    this.seq = seq;
    this.externalId = externalId;
    this.description = description;
}
}

function newEntity() {
return new EmAclDept();
}

    function gridFields() {
    return Object.freeze([
        {
            key: 'code',
            label: 'label.em.admin.emAclDept.grid.code',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclDept.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAclDept.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAclDept.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.admin.emAclDept.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAclDept.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'externalId',
        label: 'label.em.admin.emAclDept.grid.externalId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.admin.emAclDept.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idInFilter : "",
    nodeCodeStartWithFilter : "",
    codeFilter : "",
    nameFilter : "",
    parentIdFilter : "",
    parentNameFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    externalIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
            key: 'codeFilter',
            label: 'label.em.admin.emAclDept.filter.code',
            disabled: false,
            form: {
                type: 'input'
            }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclDept.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.admin.emAclDept.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'parentNameFilter',
        label: 'label.em.admin.emAclDept.filter.parentName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];
const levelTreeFilterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclDept.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
            key: 'code',
            label: 'label.em.admin.emAclDept.entity.code',
            sortable: true,
            disabled: false,
            form: {
                type: 'input'
                ,required: true
            }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclDept.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAclDept.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAclDept.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'externalId',
        label: 'label.em.admin.emAclDept.entity.externalId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'description',
        label: 'label.em.admin.emAclDept.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAclDept, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, levelTreeFilterConfigs


}
